import React, { Component } from 'react'
import FlipPage from 'react-flip-page';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import page1 from "./Black and White Low Res/page1.jpg";
import page2 from "./Black and White Low Res/page2.jpg";
import page3 from "./Black and White Low Res/page3.png";
import page4 from "./Black and White Low Res/page4.jpg";
import page5 from "./Black and White Low Res/page5.jpg";
import page6 from "./Black and White Low Res/page6.jpg";
import page7 from "./Black and White Low Res/page7.jpg";
import page8 from "./Black and White Low Res/page8.jpg";
import page9 from "./Black and White Low Res/page9.jpg";
import page10 from "./Black and White Low Res/page10.jpg";
import page11 from "./Black and White Low Res/page11.jpg";
import page12 from "./Black and White Low Res/page12.jpg";
import page13 from "./Black and White Low Res/page13.jpg";
import page14 from "./Black and White Low Res/page14.jpg";
import page15 from "./Black and White Low Res/page15.jpg";
import page16 from "./Black and White Low Res/page16.jpg";
import page17 from "./Black and White Low Res/page17.jpg";
import page18 from "./Black and White Low Res/page18.jpg";
import page19 from "./Black and White Low Res/page19.jpg";
import page20 from "./Black and White Low Res/page20.jpg";
import './styles.css'

class Comic extends Component {

    constructor(props) {
        super(props);

    
        this.flipPageSettings = {
          orientation: "horizontal",
          responsive: true,
          uncutPages: true,
          showSwipeHint: false,
          flipOnTouch: true,
          showHint: false,
          showTouchHint: false,
          treshold: 300,
          disableSwipe: true,
          pageBackground: "transparent",
          animationDuration: 400,
        };
      }

      
    
      render() {
        const screenHeight = window.innerHeight;
    
        const playerStyles = {
          touchAction: "true",
          
        };

        return (

          <div className="comicbook" style={playerStyles}>
            <FlipPage {...this.flipPageSettings}>
              <article>
              <TransformWrapper>
                <TransformComponent>
                 <img className="img" alt="" src={page1}/>
                <img className="img" alt=""  src={page2}/>
                </TransformComponent>
              </TransformWrapper>
              </article>
              <article>
              <TransformWrapper>
                <TransformComponent>
                <img className="img" alt="" src={page3}/>
                <img className="img" alt="" src={page4}/>
                </TransformComponent>
              </TransformWrapper>
              </article>
              <article>
              <TransformWrapper>
                <TransformComponent>
                <img className="img" alt="" src={page5}/>
                <img className="img" alt="" src={page6}/>
                </TransformComponent>
              </TransformWrapper>
              </article>
              <article>
              <TransformWrapper>
                <TransformComponent>
                <img className="img" alt="" src={page7}/>
                <img className="img" alt="" src={page8}/>
                </TransformComponent>
              </TransformWrapper>
              </article>
              <article>
              <TransformWrapper>
                <TransformComponent>
                <img className="img" alt="" src={page9}/>
                <img className="img" alt="" src={page10}/>
                </TransformComponent>
              </TransformWrapper>
              </article>
              <article>
              <TransformWrapper>
                <TransformComponent>
                <img className="img" alt="" src={page11}/>
                <img className="img" alt="" src={page12}/>
                </TransformComponent>
              </TransformWrapper>
              </article>
              <article>
              <TransformWrapper>
                <TransformComponent>
                <img className="img" alt="" src={page13}/>
                <img className="img" alt="" src={page14}/>
                </TransformComponent>
              </TransformWrapper>
              </article>
              <article>
              <TransformWrapper>
                <TransformComponent>
                <img className="img" alt="" src={page15}/>
                <img className="img" alt="" src={page16}/>
                </TransformComponent>
              </TransformWrapper>
              </article>
              <article>
              <TransformWrapper>
                <TransformComponent>
                <img className="img" alt="" src={page17}/>
                <img className="img" alt="" src={page18}/>
                </TransformComponent>
              </TransformWrapper>
              </article>
              <article>
              <TransformWrapper>
                <TransformComponent>
                <img className="img" alt="" src={page19}/>
                <img className="img" alt="" src={page20}/>
                </TransformComponent>
              </TransformWrapper>
              </article>
              
            
            </FlipPage>
          </div>
        );
      }
}
export default Comic;
